import { render, staticRenderFns } from "./sbjl.vue?vue&type=template&id=c4f200f4&scoped=true&"
import script from "./sbjl.vue?vue&type=script&lang=js&"
export * from "./sbjl.vue?vue&type=script&lang=js&"
import style0 from "./sbjl.vue?vue&type=style&index=0&id=c4f200f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f200f4",
  null
  
)

export default component.exports